export default __webpack_public_path__ + "static/media/funcoes-php.6b0fd991.png";